import { tokenRefreshInterceptor } from "./utils";

async function interceptedFetch(
	url: string,
	init: RequestInit,
): Promise<Response> {
	if (init) (init as any).url = url;
	const processedInit = await tokenRefreshInterceptor.handleRequest(
		(init ?? url) as any,
	);
	return window.fetch(processedInit);
}

// @ts-expect-error type inacuracy, but it works
window.interceptedFetch = interceptedFetch;
